import React, { Component } from "react";
import FlexView from "react-flexview";
import { configYearToDate, yearOptions, transformResponseYearsToDateToTable } from "../config";
import { removeNullFields } from "../../../../common/mapper";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";

class YearToDateSales extends Component {
    constructor(props) {
        super(props);
        this.state = {
            year: null,
            tableConfig: [],
            dataTable: [],
        };
    }

    componentDidMount() {
        let currentDate = new Date();
        this.setState((prevValue) => ({
            ...prevValue,
            year: yearOptions.find(item => item.value === currentDate.getFullYear()),
            tableConfig: configYearToDate(),
        }));
    };

    compareObject = (data1, data2) => {
        return JSON.stringify(data1) === JSON.stringify(data2)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.compareObject(prevProps.search, this.props.search) === false) {
            this.fetchData();
        }
    }

    handleChangeSearchValue = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
        }));
    };

    handleSearch = () => {
        this.setState(prev=>({
            ...prev,
            tableConfig: configYearToDate(prev.year?.value)
        }), ()=>this.fetchData())
    };

    fetchData = async () => {
        try {
            this.props.triggerLoading();
            const request = removeNullFields({
                kodeCabang: [this.props.search.selectedCabang],
                year: this.state.year?.value,
                employeeIdTeamLeader: this.props.idLeader,
                employeeIdSales: this.props.search.selectedSales,
            });
            const res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanPenjualanYTDMetodePembayaranDanLeasing,
                setError: this.props.setError,
                menuName: "Dashboard Level Kepala Cabang Keatas - Laporan Jualan Year To Date",
                args: request,
            });

            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataTable: transformResponseYearsToDateToTable(res.data.data),
                }));
            }
            this.props.triggerLoading();
        } catch (error) {
            this.props.triggerLoading();
            console.log("errors: ", error);
        }
    };

    render() {
        return (
            <>
                <FlexView style={{ gap: "20px", alignItems: "center" }}>
                    <SimpleDDL
                        id="select_options_year"
                        box="search"
                        name="year"
                        containerclassname="width width-250px"
                        placeholder="Tahun"
                        menuPosition="fixed"
                        isClearable
                        options={yearOptions}
                        value={this.state.year}
                        onChange={(value, { name }) => this.handleChangeSearchValue(name, value)}
                    />
                    <SimpleButton
                        styles={{ marginBottom: "15px" }}
                        onClick={this.handleSearch}
                    >Cari</SimpleButton>
                </FlexView>
                <SimpleDataTable
                    data={this.state.dataTable}
                    columns={this.state.tableConfig}
                />
            </>
        );
    }
}

export default YearToDateSales;